import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

export const enum PageIdWoofz22V4Bg {
  SEX_22V4_BG = PageId.SEX_22V4_BG,
  DOG_AGE_22V4_BG = PageId.DOG_AGE_22V4_BG,
  DOG_BREED_22V4_BG = PageId.DOG_BREED_22V4_BG,
  DOG_BREED_ID_22V4_BG = PageId.DOG_BREED_ID_22V4_BG,
  URGE_22V4_BG = PageId.URGE_22V4_BG,
  COMMANDS_61_22V4_BG = PageId.COMMANDS_61_22V4_BG,
  COMMANDS_62_22V4_BG = PageId.COMMANDS_62_22V4_BG,
  COMMANDS_63_22V4_BG = PageId.COMMANDS_63_22V4_BG,
  URGE_2_22V4_BG = PageId.URGE_2_22V4_BG,
  POTTY_22V4_BG = PageId.POTTY_22V4_BG,
  BEHAVIOR_22V4_BG = PageId.BEHAVIOR_22V4_BG,
  TRAINING_22V4_BG = PageId.TRAINING_22V4_BG,
  PREPARE_FLOW_22V4_BG = PageId.PREPARE_FLOW_22V4_BG,
  DOG_STATISTICS_22V4_BG = PageId.DOG_STATISTICS_22V4_BG,
  EMAIL_22V4_BG = PageId.EMAIL_22V4_BG,
  NEWSLETTER_URGE_22V4_BG = PageId.NEWSLETTER_URGE_22V4_BG,
  LAST_CHANCE_OFFER_22V4_BG = PageId.LAST_CHANCE_OFFER_22V4_BG,
  WELCOME_TO_WOOFZ_22V4_BG = PageId.WELCOME_TO_WOOFZ_22V4_BG,
  SUBSCRIPTIONS_22V4_BG = PageId.SUBSCRIPTIONS_22V4_BG,
  CANCEL_OFFER_22V4_BG = PageId.CANCEL_OFFER_22V4_BG,
  CHAT_UPSELL_22V4_BG = PageId.CHAT_UPSELL_22V4_BG,
  UPSELL_22V4_BG = PageId.UPSELL_22V4_BG,
  UPSELL_FEEDING_GUIDE_22V4_BG = PageId.UPSELL_FEEDING_GUIDE_22V4_BG,
  UPSELL_EMOTIONAL_SUPPORT_22V4_BG = PageId.UPSELL_EMOTIONAL_SUPPORT_22V4_BG,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_22V4_BG = PageId.DOWNLOAD_22V4_BG,
}

type TIdToPageMapWoofz22V4Bg = Record<PageIdWoofz22V4Bg, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ22V4_BG: TIdToPageMapWoofz22V4Bg = {
  sex_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/SexQuesiton').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/SexQuesiton'),
  },
  dog_age_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/DogAgeQuestion'),
  },
  dog_breed_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  dog_breed_id_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/dog-breed/breedId/BreedPhotoScreen'
      ).then((m) => ({
        default: m.BreedPhotoScreen,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/dog-breed/breedId/BreedPhotoScreen'
      ),
  },
  urge_5_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/UrgePage').then(
        (m) => ({
          default: m.UrgePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/UrgePage'),
  },
  commands_61_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/CommandsVariant61'
      ).then((m) => ({
        default: m.CommandsVariant61,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/CommandsVariant61'),
  },
  commands_62_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/CommandsVariant62'
      ).then((m) => ({
        default: m.CommandsVariant62,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/CommandsVariant62'),
  },
  commands_63_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/CommandsVariant63'
      ).then((m) => ({
        default: m.CommandsVariant63,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/CommandsVariant63'),
  },
  urge_2_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/UrgePageVariant2'
      ).then((m) => ({
        default: m.UrgePageVariant2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/UrgePageVariant2'),
  },
  potty_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/PottyQuestion'),
  },
  behavior_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/BehaviorQuestion'
      ).then((m) => ({
        default: m.BehaviorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/BehaviorQuestion'),
  },
  training_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/TrainingQuestion'
      ).then((m) => ({
        default: m.TrainingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/questions/TrainingQuestion'),
  },
  prepare_flow_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/prepare-flow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/prepare-flow/PrepareFlow'
      ),
  },
  dog_statistics_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/dog-statistics/DogStatistics'
      ).then((m) => ({
        default: m.DogStatistics,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/dog-statistics/DogStatistics'
      ),
  },
  email_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/email/Email22V4').then((m) => ({
        default: m.Email22V4,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4_bg/pages/email/Email22V4'),
  },
  newsletter_urge_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/email/components/NewsletterUrge'
      ),
  },
  last_chance_offer_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/last-chance-offer/LastChanceOfferPage'
      ).then((m) => ({
        default: m.LastChanceOfferPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/last-chance-offer/LastChanceOfferPage'
      ),
  },
  welcome_to_woofz_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/abtest/WelcomeToWoofz'
      ).then((m) => ({
        default: m.WelcomeToWoofz,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/questions/abtest/WelcomeToWoofz'
      ),
  },
  subscriptions_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/subscriptions/SubscriptionsPage'
      ),
  },
  cancel_offer_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/subscriptions/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/subscriptions/CancelOffer'),
  },
  chat_upsell_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/upsell/ChatUpsellNewFlow'),
  },
  upsell_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4_bg/pages/upsell/Upsell'),
  },
  upsell_feeding_guide_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/upsell/FeedingGuideUpsell'
      ).then((m) => ({
        default: m.FeedingGuideUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/upsell/FeedingGuideUpsell'),
  },
  upsell_emotional_support_22v4_bg: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4_bg/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/upsell/EmotionalSupportUpsell'),
  },
  account_nove8: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  download_22v4_bg: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4_bg/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4_bg/pages/download-app/DownloadApp'),
  },
}
